// https://validatejs.org/#validate-js
// init function is used because we need these validators loaded only when we use form_validator.
const init = () => {
	validate.validators.phone = (value, options, key, attributes) => {
		if (validate_phone_number(value)[0]) {
			return;
		}
		return '^' + it('ERROR_VALID_NUMBER');
	}
	validate.validators.alphanumeric = (value, options, key, attributes) => {
		if (/^[a-z0-9\s]+$/i.test(value)) {
			return;
		}
		return '^' + messages.CODE_LETTERS_NUMBERS;
	}
	validate.validators.only_letters = (value, options, key, attributes) => {
		if (/^([^\0-\x7F]|[a-zA-Z\s])+$/i.test(value)) {
			return;
		}
		return '^' + messages.ERROR_MESSAGE_LETTERS_ONLY;
	}

	validate.validators.username = (value, options, key, attributes) => {
		if (/^[a-zA-Z0-9_.-]+$/.test(value)) {
			return;
		}
		//TODO: what error to put here?
		return '^' + messages.MANDATORY_FIELD;
	}

	validate.validators.creditcard = (value, options, key, attributes) => {
		if (value && validate_credit_card(value)) {
			return;
		}
		return '^' + messages.INVALID_CARD_NUMBER;
	}

	validate.validators.us_zip = (value, options, key, attributes) => {
		if (/^(\d{5})(?:\s*-\s*(\d{4}))?$/.test(value)) {
			return;
		}

		return ('^' + messages.INVALID_ZIP_CODE).replace("{0}", value);
	}

	validate.validators.requireonealpha = (value, options, key, attributes) => {
		if (/[a-z]+/i.test(value)) {
			return;
		}

		return ('^' + messages.ERROR_MESSAGE_AT_LEAST_ONE_ALPHA).replace("{0}", value);
	}

	validate.validators.iso = (value, options, key, attributes) => {
		if (/^[\x20-\x7E\xA0-\xA3\xA5\xA7\xA9-\xB3\xB5-\xB7\xB9-\xBB\xBF-\xFF\u20AC\u0160\u0161\u017D\u017E\u0152\u0153\u0178]*$/.test(value)) {
			return;
		}

		return '^' + it('LATIN_CHARACTERS_ONLY');
	}

	validate.validators.checkout_billing_zip = (value, options, key, attributes, global) => {
		if (!options.isUS) {
			return;
		}

		if (/^(\d{5})(?:\s*-\s*(\d{4}))?$/.test(value)) {
			return;
		}

		return ('^' + messages.INVALID_ZIP_CODE).replace("{0}", value);
	}

	validate.validators.remoteEmail = (value, options, key, attributes) => {
		return new Promise(function(resolve, reject) {
			// Used for testing env
			// return resolve();

			if (!value) {
				return resolve('^' + messages.MANDATORY_FIELD);
			}

			if (validate({email: value}, {email: { email: true} })) {
				return resolve('^' +  messages.CONTACT_NO_MSG_ERR);
			}

			let formData = new FormData();
			formData.append('email', value);
			formData.append('action', 'validate_email');

			// form doesn't have its own token snowman and name hidden input fields
			// currently the first ones on found on the page are used

			const token = options?.form?.querySelector('[name="_token"]')?.value
			|| document.querySelector('[name="_token"]')?.value;

			const snowman = options?.form?.querySelector('[name="_token"]')?.value
			|| document.querySelector('[name="_snowman"]')?.value;

			const nothing =  options?.form?.querySelector('[name^="_nothing_"]')?.getAttribute('name')
			|| document.querySelector('[name^="_nothing_"]').getAttribute('name');

			formData.append('_token', token);
			formData.append('_snowman', snowman);
			formData.append(nothing, '');

			try {
				const fetch = fetcher(
					url('account/process_register'),
					{
						method: 'POST',
						body: formData,
					}
				);
				fetch.ready.then((response) => {
					// correct response should be 'true'
					if (response == 'true' || response == true) {
						if (options.onComplete) {
							options.onComplete(response);
						}
						resolve();
					} else {
						resolve('^' + messages.ERROR_EMAIL_ADDRESS_ALREADY_IN_USE);
					}
				});
			} catch (e) {
				resolve('^' + messages.ERROR_EMAIL_ADDRESS_ALREADY_IN_USE);
			}
		});
	};

	validate.validators.port_in_number = (value, options, key, attributes) => {
		if (/^\+1 \(\d{3}\) \d{3} \d{4}$/.test(value)) {
			return;
		}
		return '^' + it('ERROR_VALID_NUMBER');
	}

	// Set default Error Messages
	validate.validators.presence.message = '^' + messages.MANDATORY_FIELD;

	// this is copied from site_resources_v3\global\js\jquery.validate.js
	validate.validators.email.message = '^' + 'Please enter a valid email address.';

	validate.validators.numericality.message = '^' + 'Please enter digits only.';

	validate.validators.passwordStrongSecurity = (value, options, key, attributes) => {
		let strength = 0;
		const errorMessages = '^ Please enter a strong password.';
		const constraintsRegex = [
			/.{8,}/,
			/([a-z].*[A-Z])|([A-Z].*[a-z])/,
			/([0-9])/,
			/([^\w\s])/
		];

		if (!value) {
			return errorMessages;
		} else {
			constraintsRegex.forEach((regex, index) => {
				const isValid = regex.test(value);
				if (isValid) strength++;
			});

			if (strength === 4) {
				return;
			} else {
				return errorMessages;
			}
		}
	};
}

class FormValidator {
	constructor(options = {}) {
		this.options = {
			errorClass: "js-has-error",
			isInvalid: "inputError",
			customCssError: [],
			blockError: "js-help-block-error",
			errorMessageContainerElement: "label",
			errorMessageContainer: "js-error-message",
			inputContainer: "form-group",
			formSubmitHandler: false,
			beforeSubmitHandler: false,
			showAllErrors: false,
			autoTrim: [],
			isStarted: false,
			hasErrorContainer: false,
			errorHandler: false,
			ignoreIsHiddenInputs: true,
			clearDisabledStatusOnButton: false,
			onSubmitDisableTriggers: false,
			scrollAndFocus: true,
			// Analytics object formed of category, action and label
			event: null,
			...options,
		};

		this.form = null;
		this.constraints = null;
		this.seenInputs = [];

		init();
	}

	/**
	 * Form Validator start - Attaches an event listener to a form on submit
	 * If there are any errors then we won't submit the form
	 *
	 * @param {HTMLElement | string} form form element or formID
	 * @param {object} constraints Form Validations
	 * @returns {void}
	 */
	start(form, constraints) {
		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		if (!form) {
			return;
		}

		this.form = form;
		this.constraints = constraints;

		form.addEventListener('submit', (ev) => {
			ev.preventDefault();
			ev.stopImmediatePropagation();

			this.options.isStarted = true;
			this.handleFormSubmit(form);
		});

		// validate on change
		this.onEventValidate(form, 'input');
	}


	/**
	 * onEventValidate - Adds event listeners to a form
	 *
	 * @param {HTMLElement | string} form form element or formID
	 * @param {string} eventListenerName can be any blur, change, keypress, input
	 * @returns {void}
	 */
	onEventValidate(form, eventListenerName) {
		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		// validate on change
		const inputs = form.querySelectorAll('input, textarea, select');

		for (let i = 0; i < inputs.length; i++) {
			this.addInputEventListener(inputs.item(i), eventListenerName);
		}
	}

	addInputEventListener(input, eventListenerName) {
		input.addEventListener(eventListenerName, (event) => {
			// we only use our event listeners after a fist submit attempt
			if (!this.options.isStarted && this.seenInputs.indexOf(event.target.name) == -1) {
				return;
			}

			if (this.options.autoTrim.indexOf(event.target.name) != -1) {
				event.target.value = event.target.value.trim();
			}

			let constraints = this.constraints;
			if (this.options.ignoreIsHiddenInputs) {
				constraints = this.getConstraintsNotHidden();
			}

			validate.async(validate.collectFormValues(this.form), constraints)
				.then(() => {
					this.resetForm(event.target);
					if (this.options.clearDisabledStatusOnButton) {
						const button = this.form.querySelector('button[type="submit"]');
						if (button && button.hasAttribute('disabled')) {
							button.removeAttribute('disabled');
						}
					}
				})
				.catch((errors) => {
					if (Object.keys(errors).length === 0) {
						this.resetForm(event.target);
					}

					if (event.target.name === 'password') {
						if (this.options.errorHandler) {
							this.resetPasswordErrorCustomErrorHandler(
								event.target.name,
								errors,
								this.form
							);
						} else {
							this.resetPasswordErrorContainerInjection(
								event.target.name,
								errors,
								this.form
							);
						}
					}

					this.showErrorsForInput(
						event.target,
						errors[event.target.name]
					);
				});
		});

		input.addEventListener('blur', (event) => {
			let constraints = this.constraints;
			if (this.options.ignoreIsHiddenInputs) {
				constraints = this.getConstraintsNotHidden();
			}
			const value = input.value.trim();

			if (this.seenInputs.indexOf(input.name) == -1 && value === '' || !constraints[input.name]) {
				return;
			}

			let rules = {[input.name]: constraints[input.name]};

			if (constraints[input.name].equality) {
				const ruleName = constraints[input.name].equality.attribute;
				rules[ruleName] = constraints[ruleName];
			}

			validate.async(validate.collectFormValues(this.form), rules)
			.then(() => {
				this.resetInput(input);
			})
			.catch((errors) => {
				this.seenInputs.push(input.name);
				this.showErrorsForInput(
					input,
					errors[input.name]
				);
			});
		});
	}

	addIndividualInputEventListener(input, eventListenerName) {
		input.addEventListener(eventListenerName, (event) => {
			// we only use our event listeners after a fist submit attempt
			if (!this.options.isStarted) {
				return;
			}

			if (this.options.autoTrim.indexOf(event.target.name) != -1) {
				event.target.value = event.target.value.trim();
			}

			let constraints = this.constraints;
			if (this.options.ignoreIsHiddenInputs) {
				constraints = this.getConstraintsNotHidden();
			}

			if (!constraints[input.name]) {
				this.resetForm();
				if (this.options.clearDisabledStatusOnButton) {
					const button = this.form.querySelector('button[type="submit"]');
					if (button && button.hasAttribute('disabled')) {
						button.removeAttribute('disabled');
					}
				}
			}

			validate.async(validate.collectFormValues(this.form), {[input.name]: constraints[input.name]})
				.then(() => {
					this.resetInput(input);
					if (this.options.clearDisabledStatusOnButton) {
						const button = this.form.querySelector('button[type="submit"]');
						if (button && button.hasAttribute('disabled')) {
							button.removeAttribute('disabled');
						}
					}
				})
				.catch((errors) => {
					this.showErrorsForInput(
						event.target,
						errors[event.target.name]
					);
				});
		});
	}

	handleFormSubmit(form) {
		let constraints = this.constraints;

		if (this.options.ignoreIsHiddenInputs) {
			constraints = this.getConstraintsNotHidden();
		}
		validate.async(validate.collectFormValues(form), constraints).then(() => {
			this.submit(form);
			}).catch((errors) => {
				this.showErrors(form, errors || {});
				if (this?.options.clearSubmitButtonId) {
					document.getElementById(this?.options.clearSubmitButtonId).disabled = false;
				}
				this.scrollAndFocus();
			});
	}

	showErrors(form, errors) {
		form.querySelectorAll('input[name], select[name], textarea[name]').forEach((input) => {
			let inputName = input.getAttribute('name');

			if (errors && errors[inputName]) {
				this.showErrorsForInput(input, errors && errors[inputName]);
			}
		});
	}

	findErrorContainer(inputElement) {
		var nextSibling = inputElement.nextSibling;

		if (nextSibling.nodeType === 1
			&& nextSibling.tagName.toLowerCase() === 'span'
			&& nextSibling.classList.contains(this.options.errorMessageContainer)) {
			nextSibling.remove();
		}
		nextSibling = nextSibling.nextSibling;
	}

	showErrorsForInput(input, errors) {
		if (this.options.errorHandler) {
			// custom error handler
			const container = this.getErrorHandlerContainer(input, errors, this.form);
			this.options.errorHandler(input, errors, this.form, container);
		} else if (!this.options.hasErrorContainer) {
			// default
			// Just put the error under the input and remove it when valid
			this.findErrorContainer(input);
			input.classList.remove(this.options.isInvalid);
			if (!errors) {
				return;
			}
			let container = document.createElement('span');
			container.classList.add(this.options.errorMessageContainer)
			container.classList.add(this.options.blockError);
			container.id = `js-input-${input.name}`;
			input.classList.add(this.options.isInvalid);
			input.insertAdjacentElement('afterend', container);

			if (!this.options.showAllErrors || errors.length === 1) {
				this.addError(container, errors[0]);
			} else {
				errors.forEach((error) => {
					this.addError(container, error);
				});
			}
		} else {
			// use div containers
			const formGroup = this.closestParent(
				input.parentNode,
				this.options.inputContainer
			);

			// In case you have extra input in the form and don't want to validate it
			if (!formGroup) {
				return;
			}

			const messages = formGroup.querySelector(
				`.${this.options.errorMessageContainer}`
			);
			this.resetFormGroup(formGroup);

			if (errors) {
				formGroup.classList.add(this.options.errorClass);
				input.classList.add(this.options.isInvalid);

				// Show multiple errors for one field
				if (!this.options.showAllErrors || errors.length === 1) {
					this.addError(messages, errors[0]);
				} else {
					errors.forEach((error) => {
						this.addError(messages, error);
					});
				}
			}
		}
	}

	getErrorHandlerContainer(input, errors, form) {
		const errorName = input.getAttribute('name').replace(/\[|\]/g, '');
		const errorContainer = form.querySelector(`#js-name-${errorName}`);

		if (errorContainer) {
			input.classList.remove(this.options.isInvalid);
			errorContainer.remove();
		}

		if (!errors) {
			return;
		}

		input.classList.add(this.options.isInvalid);
		let container = document.createElement('label');
		container.classList.add(this.options.errorMessageContainer);
		container.id = `js-name-${errorName}`;
		container.classList.add(this.options.isInvalid);
		container.classList.add(this.options.blockError);

		let textNode;
		if (!this.options.showAllErrors || errors.length === 1) {
			textNode = document.createTextNode(errors[0]);
		} else {
			textNode = document.createTextNode(errors);
		}
		container.appendChild(textNode);
		return container;
	}

	// Recursively finds the closest parent that has the specified class
	closestParent(child, className) {
		if (!child || child == document) {
			return null;
		}
		if (child.classList.contains(className)) {
			return child;
		} else {
			return this.closestParent(child.parentNode, className);
		}
	}

	resetFormGroup(formGroup) {
		// basically this prevents from removing existing errors from other validators
		if (!formGroup.classList.contains(this.options.errorClass)) {
			return;
		}

		formGroup.classList.remove(this.options.errorClass);

		formGroup
			.querySelectorAll(`.${this.options.blockError}`)
			.forEach((el) => {
				el.parentNode.removeChild(el);
			});

		// remove is invalid from for inputs
		formGroup
			.querySelectorAll(`.${this.options.isInvalid}`)
			.forEach((el) => {
				el.classList.remove(this.options.isInvalid);
			});
	}

	resetForm(formGroup) {
		let form;
		if (formGroup) {
			form = formGroup.closest('form');
		} else {
			form = this.form;
		}

		form.querySelectorAll(`.${this.options.blockError}, .${this.options.errorMessageContainer}`).forEach((el) => {
			el.parentNode.removeChild(el);
		});

		// remove is invalid from for inputs
		form.querySelectorAll(`.${this.options.isInvalid}`).forEach((el) => {
			// On checkout we have a different validator for security pin and this reset error will break the error message
			// As a temporary solution we will not reset the error if it contains security_pin_
			if (!el.id.includes('security_pin_')) {
				el.classList.remove(this.options.isInvalid);
			}
		});

		form.querySelectorAll(`.${this.options.errorClass}`).forEach((el) => {
			el.classList.remove(this.options.errorClass);
		});
	}

	resetInput(input) {
		const errorContainer = document.getElementById(`js-input-${input.name}`);
		if (errorContainer) {
			errorContainer.remove();
		}

		// remove is invalid from for input
		input.classList.remove(this.options.isInvalid);
	}

	// This is an edge case fix
	// How to test: add 1234567 on confirm_password and then add 1234567 on password
	// The issue is that the error persists because we do not check it again.
	// This functions checks if we have that error displayed and remove it.
	// Also, we need to re-apply the error in case we change the password input
	// This is used and tested for having predefined divs/spans in the template
	resetPasswordErrorContainerInjection(name, errors, form) {
		try {
			if (
				name === 'password' &&
				!errors[name] &&
				!errors['confirm_password'] &&
				form.querySelectorAll(
					`.${this.options.errorClass} input[name='confirm_password'].${this.options.isInvalid}`
				).length === 1
			) {
				let errorInput = form.querySelectorAll(
					`.${this.options.errorClass} input[name='confirm_password'].${this.options.isInvalid}`
				)[0];
				let formGroupError = errorInput.closest(
					`.${this.options.errorClass}`
				);
				if (formGroupError) {
					this.resetFormGroup(formGroupError);
				}
			}

			if (
				name === 'password' &&
				!errors[name] &&
				errors['confirm_password'] &&
				form.querySelectorAll(
					`.${this.options.errorClass} input[name='confirm_password'].${this.options.isInvalid}`
				).length === 0
			) {
				let confirmInput = form.querySelectorAll(
					'input[name="confirm_password"]'
				)[0];
				let formGroup = confirmInput.closest('.form-group');
				if (formGroup) {
					formGroup.classList.add(this.options.errorClass);
					let messages = formGroup.querySelector(
						`.${this.options.errorMessageContainer}`
					);
					this.addError(messages, errors['confirm_password']);
				}

				confirmInput.classList.add(this.options.isInvalid);
			}
		} catch (error) {
			console.log('ERROR', error);
			// TODO: Log error
		}
	}

	// This is used and tested for Custom Error Handler case
	resetPasswordErrorCustomErrorHandler(name, errors, form) {
		try {
			if (
				name === 'password' &&
				!errors[name] &&
				!errors['confirm_password']
			) {
				// clear error
				const errorContainer = form.querySelector('#js-name-confirm_password');
				const inputConfirmPassword = form.querySelector('input[name="confirm_password"]');

				if (errorContainer) {
					errorContainer.remove();
				}
				if (inputConfirmPassword) {
					inputConfirmPassword.classList.remove(this.options.isInvalid);
				}
			} else if (
				name === 'password' &&
				!errors[name] &&
				errors['confirm_password']
			) {
				const errorContainer = form.querySelector('#js-name-confirm_password');

				if (errorContainer) {
					return;
				}

				const inputConfirmPassword = form.querySelector('input[name="confirm_password"]');

				inputConfirmPassword.classList.add(this.options.isInvalid);

				let container = document.createElement('label');
				container.classList.add(this.options.errorMessageContainer);
				container.id = `js-name-confirm_password`;
				container.classList.add(this.options.isInvalid);

				var textNode = document.createTextNode(errors['confirm_password']);
				container.appendChild(textNode);

				const parent = inputConfirmPassword.parentElement;
				// this is used for register form inside login_register.js
				if (parent.classList.contains('input-group')) {
					parent.insertAdjacentElement('afterend', container);
				} else {
					inputConfirmPassword.insertAdjacentElement('afterend', container);
				}
			}
		} catch (error) {
			console.log('ERROR', error);
			// TODO: Log error
		}
	}

	addError(messages, error) {
		if (!messages || !error) {
			return;
		}

		let block = document.createElement(this.options.errorMessageContainerElement);
		block.classList.add(this.options.blockError);
		block.classList.add(this.options.isInvalid);

		this.options.customCssError.forEach((e) => {
			block.classList.add(e);
		});

		block.innerText = error;
		messages.appendChild(block);
	}

	submit(form) {
		if (this.options.event) {
			s.track.event(
				this.options.event.category,
				this.options.event.action,
				this.options.event.label
			);
		}

		// Some forms like checkout have additional things to do before on submit
		const { formSubmitHandler, beforeSubmitHandler, onSubmitDisableTriggers } = this.options;

		if (onSubmitDisableTriggers) {
			this.disableSubmitTriggers(form);
		}

		if (typeof beforeSubmitHandler === 'function') {
			beforeSubmitHandler(form);
		}

		if (typeof formSubmitHandler === 'function') {
			formSubmitHandler();
		} else {
			form.submit();
		}
	}

	/**
	 * 	ajaxValidate - When we have AJAX instead of submit
	 *
	 * @param {HTMLElement | string} form form element or formID
	 * @param {object} constraints Form Validations
	 * @returns {void}
	 */
	ajaxValidate(form, constraints) {
		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		this.form = form;
		this.constraints = constraints;

		if (!this.form || !this.constraints) {
			return false;
		}

		let rules = this.constraints;
		if (this.options.ignoreIsHiddenInputs) {
			rules = this.getConstraintsNotHidden();
		}

		const errors = validate(this.form, rules);
		this.resetForm(form);
		this.showErrors(form, errors || {});
		return errors;
	}

	hasErrors() {
		if (!this.form || !this.constraints) {
			return false;
		}

		let rules = this.constraints;
		if (this.options.ignoreIsHiddenInputs) {
			rules = this.getConstraintsNotHidden();
		}

		const errors = validate(this.form, rules);
		this.resetForm(this.form);
		this.showErrors(this.form, errors || {});

		if (errors) {
			this.scrollAndFocus();
		}

		return errors;
	}

	async hasErrorsAsync() {
		if (!this.form || !this.constraints) {
			return false;
		}

		let constraints = this.constraints;
		if (this.options.ignoreIsHiddenInputs) {
			constraints = this.getConstraintsNotHidden();
		}

		let that = this;
		try {
			await validate.async(validate.collectFormValues(this.form), constraints);
			this.resetForm(this.form);
			this.submit(this.form);

			return true;
		} catch (errors) {
			that.showErrors(that.form, errors || {});
			return false;
		}
	}

	async hasErrorsAsyncAjax() {
		if (!this.form || !this.constraints) {
			return false;
		}

		let constraints = this.constraints;
		if (this.options.ignoreIsHiddenInputs) {
			constraints = this.getConstraintsNotHidden();
		}

		let that = this;
		try {
			await validate.async(validate.collectFormValues(this.form), constraints);
			this.resetForm(this.form);

			return true;
		} catch (errors) {
			that.showErrors(that.form, errors || {});
			return false;
		}
	}

	setForm(form) {
		this.form = form;
	}

	setConstraints(constraints) {
		this.constraints = constraints;
	}

	setStarted(bool) {
		this.options.isStarted = bool;
	}

	addConstraints(newConstraints) {
		this.constraints = {... this.constraints, ...newConstraints};
	}

	getConstraints() {
		return this.constraints;
	}

	removeConstraints(constraintsToRemove) {
		if (!this.constraints) {
			console.warn('removeConstraints cannot be removed because no constraints are present');
			return;
		}
		for (let constraint in constraintsToRemove) {
			if (this.constraints.hasOwnProperty(constraint)) {
				delete this.constraints[constraint];
			}
		}
	}

	// onlyErrors is to be used only to show errors and will not interfere with submit
	onlyErrors(form, constraints) {
		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		this.form = form;
		this.constraints = constraints;

		this.onEventValidate(form, 'input');
	}

	isElementVisible = (element) =>{
		if (!element) {
			return false;
		}
		return (element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	}

	// if the input doesn't exist OR if it exists and is hidden we need to ignore it
	removeConstraintsNotHidden() {
		let rules = this.constraints;
		for (let rule in rules) {
			const input = this.getInputByName(rule);
			if ((input && input.type === 'hidden' || input.classList.contains('hidden')) || !input) {
				delete rules[rule];
			}
		}
	}

	getConstraintsNotHidden() {
		let rules = Object.assign({}, this.constraints);
		for (let rule in rules) {
			const input = this.getInputByName(rule);
			if (!input || input.type === 'hidden' || input.classList.contains('hidden')) {
				delete rules[rule];
			}
		}
		return rules;
	}

	getInputByName(name) {
		const inputs = this.form.querySelectorAll('input, textarea, select');
		for (let i = 0; i < inputs.length; i++) {
			if (inputs.item(i).name === name) {
				return inputs.item(i);
			}
		}
		return null;
	}

	attachEventOnConstraints(form, constraints) {
		if (this.options.isAttachEventOnConstraints) {
			return;
		}

		this.options.isAttachEventOnConstraints = true;

		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		for (let constraint in constraints) {
			const input = form.querySelector(`[name="${constraint}"]`);
			if (input) {
				this.addIndividualInputEventListener(input, 'input');
			}
		}
	}

	isElementInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	findPreviousInput(element, limit = 10) {
		let count = 0;

		while (element && count < limit) {
			let sibling = element.previousElementSibling;
			while (sibling) {
				if (sibling.tagName === 'INPUT') {
					return sibling;
				}
				sibling = sibling.previousElementSibling;
			}

			element = element.parentElement;
			count++;
		}
		return null;
	}

	scrollAndFocus() {
		if (!this.options.scrollAndFocus) {
			return;
		}

		const element = this.form.querySelector(`.${this.options.errorMessageContainer}`);
		if (!element) {
			return;
		}

		if (!this.isElementInViewport(element)) {
			element.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		const input = this.findPreviousInput(element);
		if (input) {
			input.focus();
		}
	}

	disableSubmitTriggers(form) {
		form?.querySelectorAll('[type=submit]:not([name])').forEach(button => {
			button.disabled = true;
		});
	}

	passwordStrongSecurityMeter(form, passwordInputName) {
		if (typeof form === 'string') {
			form = document.getElementById(form);
		}

		if (form) {
			const passwordInput = form.querySelector(`input[name="${passwordInputName}"]`);
			const passwordStrength = form.querySelector('.password-strength');
			const passwordStrengthMessage = passwordStrength.querySelector('.password-strength-message .text');
			const passwordStrengthProgress = passwordStrength.querySelector('.password-strength-progress');
			const progressBars = [...passwordStrengthProgress.querySelectorAll('.bar')];
			const constraints = [...passwordStrength.querySelectorAll('.constrain')];

			passwordInput.addEventListener('input', (e) => {
				checkStrength(e.currentTarget.value);
			});

			function checkStrength(password) {
				let strength = 0;
				const progressBarStatus = ['danger', 'warning', 'success']
				const strengthMessages = [
					it('PASSWORD_SECURITY_SCORE_EMPTY'),
					it('PASSWORD_SECURITY_SCORE_VERY_WEAK'),
					it('PASSWORD_SECURITY_SCORE_WEAK'),
					it('PASSWORD_SECURITY_SCORE_GOOD'),
					it('PASSWORD_SECURITY_SCORE_STRONG')
				];
				const constraintsRegex = [
					/.{8,}/,
					/([a-z].*[A-Z])|([A-Z].*[a-z])/,
					/([0-9])/,
					/([^\w\s])/
				];

				if (!password) {
					constraints.forEach((constraint) => {
						constraint.classList.remove('color-danger');
						constraint.querySelector('.icon-alert').classList.remove('d-none');
						constraint.querySelector('.icon-check').classList.add('d-none');
					});

					progressBars.forEach((bar) => {
						bar.classList.remove(...progressBarStatus);
					});

					passwordStrengthMessage.innerHTML = strengthMessages[0];
				} else {
					constraintsRegex.forEach((regex, index) => {
						const constraint = constraints[index];
						const isValid = regex.test(password);

						if (isValid) strength++;
						constraint.classList.toggle('color-danger', !isValid);
						constraint.querySelector('.icon-alert').classList.toggle('d-none', isValid);
						constraint.querySelector('.icon-check').classList.toggle('d-none', !isValid);
					});

					progressBars.forEach((bar, index) => {
						bar.classList.remove(...progressBarStatus);

						if (strength === 0 && index === 0) {
							bar.classList.add(progressBarStatus[0]);
						}

						if (index < strength) {
							if (strength < 3) {
								bar.classList.add(progressBarStatus[0]);
							} else if (strength === 3) {
								bar.classList.add(progressBarStatus[1]);
							} else {
								bar.classList.add(progressBarStatus[2]);
							}
						}
					});

					if (strength === 0) {
						passwordStrengthMessage.innerHTML = strengthMessages[1];
					} else {
						passwordStrengthMessage.innerHTML = strengthMessages[strength];
					}
				}
			}
		}
	}
}
